const mockSeries = [{ name: 'Apples', color: 'indigo.6' }];
export default mockSeries;
